<div fxLayout="column" >
  <div fxLayout="row wrap" class="iot-platform-ui-date-range" data-cy="iot-platform-ui-date-range">
    <iot-platform-ui-form-group fxFlex [fields]="startFields()" [group]="form" />
    <iot-platform-ui-form-group fxFlex [fields]="endFields()" [group]="form" />
  </div>
  @if (form?.errors?.invalidRange) {
    <mat-error fxFlex>{{ 'FORM.ERROR_MESSAGE.INVALID_DATE_RANGE_IN_MONTHS' | translate: { value: diffInMonths() } }}</mat-error>
  }
</div>
